import React from 'react'
import {
    useMediaQuery,
    useTheme,
    Typography,
    Grid,
    Box,
} from '@material-ui/core';

import ComponentWrapper from '../../common/ComponentWrapper';
import { SalaryInput } from './SalaryInput';
import { AdvancedOptions } from './AdvancedOptions';
import { ResetCalculator } from './ResetCalculator'
import { AnnualPayCalculation } from './AnnualPayCalculation'
import { Seperator } from './Seperator';


const IncomeComponent = () => {
    const theme = useTheme();
    const small = useMediaQuery(theme.breakpoints.down('sm'));
    const paddingStyle = { paddingTop: 5, paddingBottom: 0, marginBottom: 20, paddingLeft: small ? 0 : 5, paddingRight: small ? 15 : 0 };

    const paddingStyleAdvanced = { ...paddingStyle, paddingTop: 0, backgroundColor: theme.palette.background.overlayFaint };
    //const introPaddingStyle = { ...paddingStyle, paddingLeft: small ? 10 : 15, paddingRight: 20, paddingTop:35, marginBottom:0,  justifyContent:"center", alignItems:"center"};

    const introStyle = small ? { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' } : { flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }

    const fontSize = (small ? 12 : 14);

    return (
        <ComponentWrapper title="INCOME" >


            <Box style={{ padding: 10 }}>
                <Grid container spacing={1} >
                    <Grid item xs={12} md={9} lg={10}>

                        <Box display='flex' style={introStyle}>
                            <Typography variant="body1" style={{ fontSize: fontSize }}>Enter your salary, adjust the settings and see the results in the summary below. </Typography>

                        </Box>
                    </Grid>
                    <Grid item xs={12} md={3} lg={2}>
                        <ResetCalculator />
                    </Grid>


                    <Grid item xs={12}>
                        <SalaryInput />
                    </Grid>
                </Grid>
            </Box>

            <div style={paddingStyleAdvanced} >
                <Box style={{ position: "relative", paddingLeft: 10, paddingTop: 15, paddingBottom: 15 }}>

                    <Seperator label="EXTRA SETTINGS" noPadding />
                    <Typography variant='body1'>Use these features to customise the calculations to your circumstances. The highlighted sections indicate that an adjustment has been made.</Typography>

                </Box>
                <AdvancedOptions />
            </div>
            <AnnualPayCalculation />
        </ComponentWrapper>
    )
}

export default IncomeComponent;
